import Platform from "../../../libs/utility/Platform"
import { Theme } from "../../components/constants"

export default {
    container: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    columnsContainer: {
        display: 'flex',
        flexDirection: "row",
        gap: "20px",
        marginTop: "80px",
    },
    column: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
        flex: 1,
    },
    buttonHeading: {
        marginTop: "20px",
        width: "57%",
        textAlign: "center",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    cardHeading: {
        marginTop: "20px",
        width: "57%",
        textAlign: "center",
        marginBottom: '20px',
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333'
    },
    cardCustomStyles: {
        backgroundColor: "#EAEEE9",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        maxWidth: "1575px",
    },
    grayBorder: {
        borderBottom: "0.5px solid #959AAA",
        width: "80%",
        margin: "20px 0px"
    },
    leftColInnerDiv: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "center",
        alignItems: 'center',
    },
    colInnerDivTopSec: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: 'center',
        marginTop: "50px",
    },
    leftColInnerDivBottomSec: {
        marginTop: "127px",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: 'center',
    },
    rightColInnerDivBottomSec: {
        marginTop: '0px',
    },
    iconsContainer: {
        display: "flex",
        flexWrap: 'wrap',
        gap: "25px",
        justifyContent: 'center',
        maxWidth: '1400px',
    },
    iconSize: {
        width: '160px',
        height: '80px',
        marginBottom: '-18px'
    },
    iconSizeFreshBooks: {
        width: '150px',
        height: '60px',
    },
    iconSizeBottomMargin: {
        width: '160px',
        height: '80px',
        marginBottom: '-40px'
    },
    iconSizeAccountingsuite: {
        width: '206px',
        height: '85px',
        marginBottom: '-18px'
    },
    xeroLogo: {
        width: "70px"
    },
    integrationButtonStyle: {
        backgroundColor: 'white',
        border: '1px solid lightgray',
        borderRadius: '20px',
        padding: '15px',
        margin: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '200px',
        marginRight: '20px',
        textAlign: 'center',
    },
    logoButtonStyle: {
        display: 'flex',
        marginBottom: '20px'
    },
    classicButtonStyle: {
        marginLeft: '5px'
    },
    classicNoteStyle: {
        display: 'flex',
        alignItems: 'center'
    },
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginBottom: "30px",
        overflow: 'hidden',
    },
    titleRow: {
        display: "flex",
        flexDirection: "row",
    },
    headerTitle: {
        display: "flex",
        flexDirection: "column",
    },
    boxListContainer: {
        display: "flex",
        flexDirection: "column",
        marginTop: "20px",
        flex: 1,
        overflow: 'auto'
    },
    boxListRow: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "30px",
        flex: 1,
    },
    tobeSelectedBoxesContainer: {
        display: "flex",
        flexDirection: "column",
        width: Platform.isMobileView() ? "100%" : "30%",
        gap: "10px",
    },
    selectedBoxesValuesContainer: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        background: Theme.WHITE_BACKGROUND,
        width: Platform.isMobileView() ? "100%" : "65%",
        padding: "30px",
        gap: "20px",
        alignContent: "flex-start",
    },
    instructionCard: {
        border: '1px solid #ccc',
        borderRadius: '12px',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        width: '100%',
        maxWidth: '1400px',
        margin: '20px',
    },
    title: {
        marginBottom: '20px',
        fontSize: '28px',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#333',
    },
    instructions: {
        fontSize: '16px',
        lineHeight: '1.6',
    },
    popupContainer: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        borderRadius: '5px',
        padding: '20px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        maxWidth: '80%',
    },
    popupTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    popupContent: {
        marginBottom: '20px',
    },
    popupParagraph: {
        marginBottom: '10px',
    },
    nextButtonMargin: {
        marginLeft: '300px'
    }
}

